import { Injectable, signal } from '@angular/core';

export interface NavItem {
  label: string;
  route?: string;
  externalUrl?: string;
  children?: NavItem[];
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  // Using Angular signals for reactive state
  isMobileMenuOpen = signal(false);
  openDropdown = signal<string | null>(null);

  navItems: NavItem[] = [
    { label: 'Home', route: '/' },
    {
      label: 'Schützenkreis',
      children: [
        { label: 'Kontakt', route: '/kontakt' },
        { label: 'Vereine', route: '/vereine' },
        { label: 'Karte', externalUrl: 'https://umap.openstreetmap.de/de/map/schutzenkreis-oberschwaben-sud_89977#11/47.7816/9.6831' }
      ]
    },
    { label: 'Termine', route: '/termine'},
    { label: 'Ausschreibungen', route: '/ausschreibungen' },
    { label: 'Ergebnisse', route: '/ergebnisse' },
    {
      label: 'Online-Melder',
      children: [
        { label: 'Ergebnisse und Tabellen', externalUrl: 'https://www.rwk-onlinemelder.de/online/listen/wsvsk74' },
        { label: 'Meldung Ergebnis', externalUrl: 'https://www.rwk-onlinemelder.de/online/wsvsk74' },
        { label: 'Meldung Mannschaft', externalUrl: 'https://www.rwk-onlinemelder.de/planung/club/wsvsk74' }
      ]
    }
  ];

  toggleMobileMenu() {
    this.isMobileMenuOpen.update(value => !value);
  }

  closeMobileMenu() {
    this.isMobileMenuOpen.set(false);
    this.openDropdown.set(null);
  }

  toggleDropdown(label: string) {
    this.openDropdown.update(current => current === label ? null : label);
  }

  closeDropdown() {
    this.openDropdown.set(null);
  }
}
